module.exports = __webpack_public_path__ + "img/avatar.89b273f8.png";